import { ActionsCreator } from '@/store/utils';

export default ActionsCreator([
  {
    name: 'updateUsersMe',
    mutation: 'UPDATE_USERS_ME'
  }
]);
